/**
 * Message id of the human-readable agency label (ISBN/ISMN).
 *
 * The parameter is a plain string on purpose: the generated API types repeat the same ISBN/ISMN enum for
 * every schema that carries an agency (`ProductNumberFeasibilityResponseAgencyEnum`,
 * `InternationalPrefixAgencyEnum`, ...), and those enums are not mutually assignable.
 */
export var getAgencyLabelMessageId = function (agency) {
    return agency === "ISMN"
        ? "ui-br-agency.product-number.assign.agency.ismn"
        : "ui-br-agency.product-number.assign.agency.isbn";
};
